import { Alert, Button } from '@shared/components';

interface Props {
    onRefresh: () => void;
}

export function CancellationRefreshPrompt({ onRefresh }: Props) {
    return (
        <Alert variant="info" role="status" className="flex flex-wrap items-center justify-between gap-3">
            <span>The cancellation is taking longer than usual. The page stops checking automatically.</span>
            <Button
                type="button"
                size="xs"
                variant="info"
                appearance="outline"
                className="shrink-0 whitespace-nowrap"
                onClick={onRefresh}
            >
                Refresh
            </Button>
        </Alert>
    );
}
